<script>
    import { section } from "../store/section.js";

    import { active_workspace } from "../store/workspace.js";
    import { active_subscription } from "../store/subscription.js";
    import { token } from "../store/token.js";

    let workspace_title = $active_workspace.title;
    let error_message;
    let success_message;

    var seat_count = 2;

    const PER_SEAT_MAPPING = {
        individual: {
            readable: "Individual",
            price_per_seat: 15,
            chargebee_plan_id: "workspace-individual-seats-yearly",
            min_seat_count: 1,
            max_seat_count: 2,
            default_storage: {
                readable: "15 GB",
            },
        },
        team: {
            readable: "Business",
            price_per_seat: 25,
            chargebee_plan_id: "workspace-team-seats-yearly",
            min_seat_count: 3,
            max_seat_count: 15,
            default_storage: {
                readable: "30 GB",
            },
        },
        organisation: {
            readable: "Enterprise",
            price_per_seat: 50,
            chargebee_plan_id: "workspace-seats-yearly",
            min_seat_count: 16,
            max_seat_count: 999,
            default_storage: {
                readable: "30 GB",
            },
        },
    };

    const PER_STORAGE_MAPPING = {
        storage_default: {
            readable: (selected_plan) => {
                return PER_SEAT_MAPPING[selected_plan || "team"].default_storage
                    .readable;
            },
            price: 0,
            chargebee_addon_id: null,
        },
        storage_250GB: {
            readable: "250 GB",
            price: 0,
            chargebee_addon_id: null,
        },
        storage_1TB: {
            readable: "1 TB",
            price: 60,
            chargebee_addon_id: "1-tb-storage-yearly",
        },
        storage_2TB: {
            readable: "2 TB",
            price: 120,
            chargebee_addon_id: "2-tb-storage-yearly",
        },
        storage_5TB: {
            readable: "5 TB",
            price: 300,
            chargebee_addon_id: "5-tb-storage-yearly",
        },
    };

    const STORAGE_ADDON_TO_READABLE_TITLE_MAPPING = {
        undefined: "250 GB",
        "1-tb-storage-yearly": "1 TB",
        "2-tb-storage-yearly": "2 TB",
        "5-tb-storage-yearly": "5 TB",
    };

    var selected_plan = null;
    let selected_payment_method = null;

    const DEFAULT_PLAN = "team";
    const DEFAULT_STORAGE = "storage_250GB";

    const select_plan = (plan_id, disable_seat_update_flag) => {
        if (PER_SEAT_MAPPING[plan_id] == undefined) {
            return (selected_plan = null);
        }

        if (selected_plan == plan_id) {
            //selected_plan = null;
        } else {
            selected_plan = plan_id;
        }

        if (!disable_seat_update_flag) {
            seat_count =
                PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].min_seat_count;
        }
    };

    var selected_storage = null;
    var storage_section_opened = false;

    const select_storage = (storage_id) => {
        if (selected_storage == storage_id) {
            //selected_storage = null;
        } else {
            selected_storage = storage_id;
        }
    };

    console.log($active_workspace);
    console.log($active_subscription);

    var filtered_storage = Object.keys(PER_STORAGE_MAPPING).filter(
        (storage_id) => {
            return (
                PER_STORAGE_MAPPING[storage_id].chargebee_addon_id ==
                $active_subscription.addon_id
            );
        },
    );

    if (filtered_storage[0]) {
        select_storage(filtered_storage[0]);
    }

    var filtered_plan = Object.keys(PER_SEAT_MAPPING).filter((plan_id) => {
        return (
            PER_SEAT_MAPPING[plan_id].chargebee_plan_id ==
            $active_subscription.plan_id
        );
    });

    if (filtered_plan[0]) {
        select_plan(filtered_plan[0]);
    }

    if ($active_subscription.plan_quantity) {
        seat_count = $active_subscription.plan_quantity;
    }

    const cancel_subscription = (subscription) => {
        confirm(`Do you really want to cancel subscription?`);
    };

    // ----

    import { fade, slide } from "svelte/transition";
    import { blur } from "svelte/transition";

    import { modal } from "../store/modal.js";
    import { workspace_name } from "../store/workspace_name.js";
    import { workspace_id } from "../store/workspace_id.js";
    import { workspace_list } from "../store/workspace_list.js";
    import HeadingContent from "./component/HeadingContent.svelte";

    const closeModal = (modal_name) => {
        modal[modal_name] = "closed";
        modal.set(modal);
    };

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    let summary_sidebar_active = false;

    $: currently_selected_plan_readable =
        PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].readable;

    $: current_price_per_seat =
        PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].price_per_seat;

    $: current_storage_price =
        PER_STORAGE_MAPPING[selected_storage || DEFAULT_STORAGE].price;

    $: final_price_per_seats = current_price_per_seat * seat_count;

    $: final_price =
        current_price_per_seat * seat_count + current_storage_price;

    const increment_seat_count = () => {
        if (
            seat_count <
            PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].max_seat_count
        ) {
            seat_count++;
        } else {
            if (selected_plan == "individual") {
                seat_count++;
                select_plan("team", true);
                return;
            }

            if (selected_plan == "team") {
                seat_count++;
                select_plan("organisation", true);
                return;
            }
        }
    };

    const decrement_seat_count = () => {
        if (
            seat_count >
            PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].min_seat_count
        ) {
            seat_count--;
        } else {
            if (selected_plan == "organisation") {
                seat_count--;
                select_plan("team", true);
                return;
            }

            if (selected_plan == "team") {
                seat_count--;
                select_plan("individual", true);
                return;
            }
        }
    };

    var selected_seats = false;

    var cardComponent = null;

    const initChargebee = async () => {
        console.log("loaded");
        if (window.Chargebee == undefined) {
            return setTimeout(() => {
                initChargebee();
            }, 500);
        }

        var cb_instance = window.Chargebee.init({
            site: `${process.env.CHARGEBEE_SITE}`,
            publishableKey: `${process.env.PUBLISHABLE_KEY}`,
        });

        console.log("cb_instance", cb_instance);
        var options = {
            icon: true,
            classes: {
                focus: "focus",
                invalid: "invalid",
                empty: "empty",
                complete: "complete",
            },
            style: {
                base: {
                    fontSize: `16px`,
                    fontFamily: "Helvetica Neue",
                    fontWeight: "300",
                    color: "#fff",
                },
            },
        };

        cb_instance.load("components").then(() => {
            cardComponent = cb_instance.createComponent("card", options);
            cardComponent.createField("number").at("#card-number");
            cardComponent.createField("cvv").at("#card-cvc");
            cardComponent.createField("expiry").at("#card-expiry");
            cardComponent.mount();
        });
    };

    function initRegionSelector() {
        jQuery(".payment-details__select-wrapper select").countrySelector({
            value: "PLH",
        });
    }

    //  country selector
    ("use strict");
    (function (n) {
        function o(n, t) {
            return n ? (typeof n != "string" ? [] : n.split(t)) : [];
        }
        var f = 0,
            i = 1,
            e = 2,
            t = 3,
            u = [
                ["PLH", "PLHD", 1, "Country"],
                ["AF", "AFG", 4, "Afghanistan"],
                ["AX", "ALA", 248, "Åland Islands"],
                ["AL", "ALB", 8, "Albania"],
                ["DZ", "DZA", 12, "Algeria"],
                ["AS", "ASM", 16, "American Samoa"],
                ["AD", "AND", 20, "Andorra"],
                ["AO", "AGO", 24, "Angola"],
                ["AI", "AIA", 660, "Anguilla"],
                ["AQ", "ATA", 10, "Antarctica"],
                ["AG", "ATG", 28, "Antigua and Barbuda"],
                ["AR", "ARG", 32, "Argentina"],
                ["AM", "ARM", 51, "Armenia"],
                ["AW", "ABW", 533, "Aruba"],
                ["AU", "AUS", 36, "Australia"],
                ["AT", "AUT", 40, "Austria"],
                ["AZ", "AZE", 31, "Azerbaijan"],
                ["BS", "BHS", 44, "Bahamas"],
                ["BH", "BHR", 48, "Bahrain"],
                ["BD", "BGD", 50, "Bangladesh"],
                ["BB", "BRB", 52, "Barbados"],
                ["BY", "BLR", 112, "Belarus"],
                ["BE", "BEL", 56, "Belgium"],
                ["BZ", "BLZ", 84, "Belize"],
                ["BJ", "BEN", 204, "Benin"],
                ["BM", "BMU", 60, "Bermuda"],
                ["BT", "BTN", 64, "Bhutan"],
                ["BO", "BOL", 68, "Bolivia (Plurinational State of)"],
                ["BQ", "BES", 535, "Bonaire, Sint Eustatius and Saba"],
                ["BA", "BIH", 70, "Bosnia and Herzegovina"],
                ["BW", "BWA", 72, "Botswana"],
                ["BV", "BVT", 74, "Bouvet Island"],
                ["BR", "BRA", 76, "Brazil"],
                ["IO", "IOT", 86, "British Indian Ocean Territory"],
                ["BN", "BRN", 96, "Brunei Darussalam"],
                ["BG", "BGR", 100, "Bulgaria"],
                ["BF", "BFA", 854, "Burkina Faso"],
                ["BI", "BDI", 108, "Burundi"],
                ["KH", "KHM", 116, "Cambodia"],
                ["CM", "CMR", 120, "Cameroon"],
                ["CA", "CAN", 124, "Canada"],
                ["CV", "CPV", 132, "Cabo Verde"],
                ["KY", "CYM", 136, "Cayman Islands"],
                ["CF", "CAF", 140, "Central African Republic"],
                ["TD", "TCD", 148, "Chad"],
                ["CL", "CHL", 152, "Chile"],
                ["CN", "CHN", 156, "China"],
                ["CX", "CXR", 162, "Christmas Island"],
                ["CC", "CCK", 166, "Cocos (Keeling) Islands"],
                ["CO", "COL", 170, "Colombia"],
                ["KM", "COM", 174, "Comoros"],
                ["CG", "COG", 178, "Congo"],
                ["CD", "COD", 180, "Congo (Democratic Republic of the)"],
                ["CK", "COK", 184, "Cook Islands"],
                ["CR", "CRI", 188, "Costa Rica"],
                ["CI", "CIV", 384, "Côte d'Ivoire"],
                ["HR", "HRV", 191, "Croatia"],
                ["CU", "CUB", 192, "Cuba"],
                ["CW", "CUW", 531, "Curaçao"],
                ["CY", "CYP", 196, "Cyprus"],
                ["CZ", "CZE", 203, "Czech Republic"],
                ["DK", "DNK", 208, "Denmark"],
                ["DJ", "DJI", 262, "Djibouti"],
                ["DM", "DMA", 212, "Dominica"],
                ["DO", "DOM", 214, "Dominican Republic"],
                ["EC", "ECU", 218, "Ecuador"],
                ["EG", "EGY", 818, "Egypt"],
                ["SV", "SLV", 222, "El Salvador"],
                ["GQ", "GNQ", 226, "Equatorial Guinea"],
                ["ER", "ERI", 232, "Eritrea"],
                ["EE", "EST", 233, "Estonia"],
                ["ET", "ETH", 231, "Ethiopia"],
                ["FK", "FLK", 238, "Falkland Islands (Malvinas)"],
                ["FO", "FRO", 234, "Faroe Islands"],
                ["FJ", "FJI", 242, "Fiji"],
                ["FI", "FIN", 246, "Finland"],
                ["FR", "FRA", 250, "France"],
                ["GF", "GUF", 254, "French Guiana"],
                ["PF", "PYF", 258, "French Polynesia"],
                ["TF", "ATF", 260, "French Southern Territories"],
                ["GA", "GAB", 266, "Gabon"],
                ["GM", "GMB", 270, "Gambia"],
                ["GE", "GEO", 268, "Georgia"],
                ["DE", "DEU", 276, "Germany"],
                ["GH", "GHA", 288, "Ghana"],
                ["GI", "GIB", 292, "Gibraltar"],
                ["GR", "GRC", 300, "Greece"],
                ["GL", "GRL", 304, "Greenland"],
                ["GD", "GRD", 308, "Grenada"],
                ["GP", "GLP", 312, "Guadeloupe"],
                ["GU", "GUM", 316, "Guam"],
                ["GT", "GTM", 320, "Guatemala"],
                ["GG", "GGY", 831, "Guernsey"],
                ["GN", "GIN", 324, "Guinea"],
                ["GW", "GNB", 624, "Guinea-Bissau"],
                ["GY", "GUY", 328, "Guyana"],
                ["HT", "HTI", 332, "Haiti"],
                ["HM", "HMD", 334, "Heard Island and McDonald Islands"],
                ["VA", "VAT", 336, "Holy See"],
                ["HN", "HND", 340, "Honduras"],
                ["HK", "HKG", 344, "Hong Kong"],
                ["HU", "HUN", 348, "Hungary"],
                ["IS", "ISL", 352, "Iceland"],
                ["IN", "IND", 356, "India"],
                ["ID", "IDN", 360, "Indonesia"],
                ["IR", "IRN", 364, "Iran (Islamic Republic of)"],
                ["IQ", "IRQ", 368, "Iraq"],
                ["IE", "IRL", 372, "Ireland"],
                ["IM", "IMN", 833, "Isle of Man"],
                ["IL", "ISR", 376, "Israel"],
                ["IT", "ITA", 380, "Italy"],
                ["JM", "JAM", 388, "Jamaica"],
                ["JP", "JPN", 392, "Japan"],
                ["JE", "JEY", 832, "Jersey"],
                ["JO", "JOR", 400, "Jordan"],
                ["KZ", "KAZ", 398, "Kazakhstan"],
                ["KE", "KEN", 404, "Kenya"],
                ["KI", "KIR", 296, "Kiribati"],
                ["KP", "PRK", 408, "Korea (Democratic People's Republic of)"],
                ["KR", "KOR", 410, "Korea (Republic of)"],
                ["KW", "KWT", 414, "Kuwait"],
                ["KG", "KGZ", 417, "Kyrgyzstan"],
                ["LA", "LAO", 418, "Lao People's Democratic Republic"],
                ["LV", "LVA", 428, "Latvia"],
                ["LB", "LBN", 422, "Lebanon"],
                ["LS", "LSO", 426, "Lesotho"],
                ["LR", "LBR", 430, "Liberia"],
                ["LY", "LBY", 434, "Libya"],
                ["LI", "LIE", 438, "Liechtenstein"],
                ["LT", "LTU", 440, "Lithuania"],
                ["LU", "LUX", 442, "Luxembourg"],
                ["MO", "MAC", 446, "Macao"],
                [
                    "MK",
                    "MKD",
                    807,
                    "Macedonia (the former Yugoslav Republic of)",
                ],
                ["MG", "MDG", 450, "Madagascar"],
                ["MW", "MWI", 454, "Malawi"],
                ["MY", "MYS", 458, "Malaysia"],
                ["MV", "MDV", 462, "Maldives"],
                ["ML", "MLI", 466, "Mali"],
                ["MT", "MLT", 470, "Malta"],
                ["MH", "MHL", 584, "Marshall Islands"],
                ["MQ", "MTQ", 474, "Martinique"],
                ["MR", "MRT", 478, "Mauritania"],
                ["MU", "MUS", 480, "Mauritius"],
                ["YT", "MYT", 175, "Mayotte"],
                ["MX", "MEX", 484, "Mexico"],
                ["FM", "FSM", 583, "Micronesia (Federated States of)"],
                ["MD", "MDA", 498, "Moldova (Republic of)"],
                ["MC", "MCO", 492, "Monaco"],
                ["MN", "MNG", 496, "Mongolia"],
                ["ME", "MNE", 499, "Montenegro"],
                ["MS", "MSR", 500, "Montserrat"],
                ["MA", "MAR", 504, "Morocco"],
                ["MZ", "MOZ", 508, "Mozambique"],
                ["MM", "MMR", 104, "Myanmar"],
                ["NA", "NAM", 516, "Namibia"],
                ["NR", "NRU", 520, "Nauru"],
                ["NP", "NPL", 524, "Nepal"],
                ["NL", "NLD", 528, "Netherlands"],
                ["NC", "NCL", 540, "New Caledonia"],
                ["NZ", "NZL", 554, "New Zealand"],
                ["NI", "NIC", 558, "Nicaragua"],
                ["NE", "NER", 562, "Niger"],
                ["NG", "NGA", 566, "Nigeria"],
                ["NU", "NIU", 570, "Niue"],
                ["NF", "NFK", 574, "Norfolk Island"],
                ["MP", "MNP", 580, "Northern Mariana Islands"],
                ["NO", "NOR", 578, "Norway"],
                ["OM", "OMN", 512, "Oman"],
                ["PK", "PAK", 586, "Pakistan"],
                ["PW", "PLW", 585, "Palau"],
                ["PS", "PSE", 275, "Palestine, State of"],
                ["PA", "PAN", 591, "Panama"],
                ["PG", "PNG", 598, "Papua New Guinea"],
                ["PY", "PRY", 600, "Paraguay"],
                ["PE", "PER", 604, "Peru"],
                ["PH", "PHL", 608, "Philippines"],
                ["PN", "PCN", 612, "Pitcairn"],
                ["PL", "POL", 616, "Poland"],
                ["PT", "PRT", 620, "Portugal"],
                ["PR", "PRI", 630, "Puerto Rico"],
                ["QA", "QAT", 634, "Qatar"],
                ["RE", "REU", 638, "Réunion"],
                ["RO", "ROU", 642, "Romania"],
                ["RU", "RUS", 643, "Russian Federation"],
                ["RW", "RWA", 646, "Rwanda"],
                ["BL", "BLM", 652, "Saint Barthélemy"],
                [
                    "SH",
                    "SHN",
                    654,
                    "Saint Helena, Ascension and Tristan da Cunha",
                ],
                ["KN", "KNA", 659, "Saint Kitts and Nevis"],
                ["LC", "LCA", 662, "Saint Lucia"],
                ["MF", "MAF", 663, "Saint Martin (French part)"],
                ["PM", "SPM", 666, "Saint Pierre and Miquelon"],
                ["VC", "VCT", 670, "Saint Vincent and the Grenadines"],
                ["WS", "WSM", 882, "Samoa"],
                ["SM", "SMR", 674, "San Marino"],
                ["ST", "STP", 678, "Sao Tome and Principe"],
                ["SA", "SAU", 682, "Saudi Arabia"],
                ["SN", "SEN", 686, "Senegal"],
                ["RS", "SRB", 688, "Serbia"],
                ["SC", "SYC", 690, "Seychelles"],
                ["SL", "SLE", 694, "Sierra Leone"],
                ["SG", "SGP", 702, "Singapore"],
                ["SX", "SXM", 534, "Sint Maarten (Dutch part)"],
                ["SK", "SVK", 703, "Slovakia"],
                ["SI", "SVN", 705, "Slovenia"],
                ["SB", "SLB", 90, "Solomon Islands"],
                ["SO", "SOM", 706, "Somalia"],
                ["ZA", "ZAF", 710, "South Africa"],
                [
                    "GS",
                    "SGS",
                    239,
                    "South Georgia and the South Sandwich Islands",
                ],
                ["SS", "SSD", 728, "South Sudan"],
                ["ES", "ESP", 724, "Spain"],
                ["LK", "LKA", 144, "Sri Lanka"],
                ["SD", "SDN", 729, "Sudan"],
                ["SR", "SUR", 740, "Suriname"],
                ["SJ", "SJM", 744, "Svalbard and Jan Mayen"],
                ["SZ", "SWZ", 748, "Swaziland"],
                ["SE", "SWE", 752, "Sweden"],
                ["CH", "CHE", 756, "Switzerland"],
                ["SY", "SYR", 760, "Syrian Arab Republic"],
                ["TW", "TWN", 158, "Taiwan, Province of China"],
                ["TJ", "TJK", 762, "Tajikistan"],
                ["TZ", "TZA", 834, "Tanzania, United Republic of"],
                ["TH", "THA", 764, "Thailand"],
                ["TL", "TLS", 626, "Timor-Leste"],
                ["TG", "TGO", 768, "Togo"],
                ["TK", "TKL", 772, "Tokelau"],
                ["TO", "TON", 776, "Tonga"],
                ["TT", "TTO", 780, "Trinidad and Tobago"],
                ["TN", "TUN", 788, "Tunisia"],
                ["TR", "TUR", 792, "Turkey"],
                ["TM", "TKM", 795, "Turkmenistan"],
                ["TC", "TCA", 796, "Turks and Caicos Islands"],
                ["TV", "TUV", 798, "Tuvalu"],
                ["UG", "UGA", 800, "Uganda"],
                ["UA", "UKR", 804, "Ukraine"],
                ["AE", "ARE", 784, "United Arab Emirates"],
                [
                    "GB",
                    "GBR",
                    826,
                    "United Kingdom of Great Britain and Northern Ireland",
                ],
                ["US", "USA", 840, "United States of America"],
                ["UM", "UMI", 581, "United States Minor Outlying Islands"],
                ["UY", "URY", 858, "Uruguay"],
                ["UZ", "UZB", 860, "Uzbekistan"],
                ["VU", "VUT", 548, "Vanuatu"],
                ["VE", "VEN", 862, "Venezuela (Bolivarian Republic of)"],
                ["VN", "VNM", 704, "Viet Nam"],
                ["VG", "VGB", 92, "Virgin Islands (British)"],
                ["VI", "VIR", 850, "Virgin Islands (U.S.)"],
                ["WF", "WLF", 876, "Wallis and Futuna"],
                ["EH", "ESH", 732, "Western Sahara"],
                ["YE", "YEM", 887, "Yemen"],
                ["ZM", "ZMB", 894, "Zambia"],
                ["ZW", "ZWE", 716, "Zimbabwe"],
            ],
            r = {
                init: function (r) {
                    return (
                        (r = r || {}),
                        this.each(function () {
                            var h = n(this),
                                p = r.value || h.val() || h.attr("value"),
                                a =
                                    r.codeMode ||
                                    h.data("code-mode") ||
                                    "alpha3",
                                w =
                                    r.showFlag === undefined
                                        ? h.data("show-flag")
                                        : r.showFlag,
                                l = a == "alpha2" ? f : a == "numeric" ? e : i,
                                v = r.valueSet || o(h.data("value-set"), " "),
                                y =
                                    v.length == 0
                                        ? u
                                        : n.grep(u, function (n) {
                                              return v.indexOf(n[l]) >= 0;
                                          }),
                                c,
                                s;
                            w
                                ? (function () {
                                      var f = function (n) {
                                              var i = s.scrollTop(),
                                                  t = n.position().top,
                                                  r = t + n.height();
                                              (t < 0 || r > s.height()) &&
                                                  s.scrollTop(i + t);
                                          },
                                          r = function (n) {
                                              var r = n.data("country"),
                                                  u;
                                              c.find("span.cs-flag-selected")
                                                  .removeClass()
                                                  .addClass(
                                                      "cs-flag-selected cs-flag " +
                                                          r[i],
                                                  );
                                              c.find(
                                                  "span.cs-name-selected",
                                              ).text(r[t]);
                                              u = r[l];
                                              h.val(u).change();
                                              n.addClass("cs-selected")
                                                  .siblings()
                                                  .removeClass("cs-selected");
                                              f(n);
                                          },
                                          u = function (n) {
                                              var i =
                                                      s.children(
                                                          "li.cs-selected",
                                                      ),
                                                  t = null;
                                              i.length == 0
                                                  ? (t = s.children("li:first"))
                                                  : n == "up"
                                                    ? (t = i.prev())
                                                    : n == "down" &&
                                                      (t = i.next());
                                              t.length > 0 && r(t);
                                          },
                                          e = function (i) {
                                              s.children("li").each(
                                                  function () {
                                                      var u = n(this),
                                                          f = u.data("country"),
                                                          e = f[t];
                                                      if (e.indexOf(i) === 0)
                                                          return r(u), !1;
                                                  },
                                              );
                                          },
                                          o = function () {
                                              var n = c.position(),
                                                  t = n.left,
                                                  i = n.top + c.outerHeight();
                                              s.css({
                                                  left: t + "px",
                                                  top: i + "px",
                                              }).show();
                                          },
                                          a = function (t) {
                                              s.children("li").each(
                                                  function () {
                                                      var i = n(this),
                                                          u = i.data("country"),
                                                          f = u[l];
                                                      if (t == f)
                                                          return r(i), !1;
                                                  },
                                              );
                                          };
                                      h.hide().attr("autocomplete", "off");
                                      c = n(
                                          '<div class="cs-selector" tabindex="0"><span class="cs-flag-selected cs-flag XXX"></span><span class="cs-name-selected"></span><span class="cs-arrow"></span></div>',
                                      ).insertAfter(h);
                                      s = n(
                                          '<ul class="cs-list" style="display: none;"></ul>',
                                      ).insertAfter(c);
                                      c.on("focus click", o)
                                          .blur(function () {
                                              window.setTimeout(function () {
                                                  s.hide();
                                              }, 200);
                                          })
                                          .keydown(function (n) {
                                              var t = n.keyCode;
                                              switch (t) {
                                                  case 38:
                                                      u("up");
                                                      n.preventDefault();
                                                      return;
                                                  case 40:
                                                      u("down");
                                                      n.preventDefault();
                                                      return;
                                              }
                                              t >= 65 &&
                                                  t <= 90 &&
                                                  (e(String.fromCharCode(t)),
                                                  n.preventDefault());
                                          });
                                      s.on("click", "li", function (t) {
                                          r(n(t.target));
                                          s.hide();
                                      });
                                      n.each(y, function (r, u) {
                                          n(
                                              '<li><span class="cs-flag ' +
                                                  u[i] +
                                                  '"></span>' +
                                                  u[t] +
                                                  "</li>",
                                          )
                                              .data("country", u)
                                              .appendTo(s);
                                      });
                                      a(h.val());
                                  })()
                                : (h.empty(),
                                  n.each(y, function (i, r) {
                                      n(
                                          '<option value="' +
                                              r[0] +
                                              '">' +
                                              r[t] +
                                              "</option>",
                                      )
                                          .data("country", r)
                                          .appendTo(h);
                                  }),
                                  h.val(p));
                        })
                    );
                },
            };
        n.fn.countrySelector = function (t) {
            console.log("selected", t);
            if (r[t])
                return r[t].apply(
                    this,
                    Array.prototype.slice.call(arguments, 1),
                );
            if (typeof t != "object" && t)
                n.error(
                    "Method " + t + " does not exist on jQuery.countrySelector",
                );
            else return r.init.apply(this, arguments);
        };
        n("select[data-role=country-selector]").countrySelector();
    })(jQuery);

    setTimeout(() => {
        initRegionSelector();
    }, 500);

    let input_name;
    let input_billingZip;
    let input_billingCountry;
    let input_vatId;

    var access_token = $token;
    var current_workspace_name = $workspace_name;

    let billing_processing_state = false;
    let billing_purchase_button_text = "Purchase";
    let billing_error_text;

    const handle_billing_error = (err) => {
        console.log(err);
        console.log(err.code);
        console.log(err.message);
        console.log(err.type);
        billing_processing_state = false;
        billing_purchase_button_text = "Purchase";

        if (err.code.indexOf("CARD") > -1) {
            billing_error_text = `Credit card error: ${err.message}`;
        } else if (err.code == "ChargebeeClientError") {
            billing_error_text = `Country selection error: ${err.message}`;
        } else {
            billing_error_text = err.message;
        }

        setTimeout(() => {
            billing_error_text = null;
        }, 5000);
    };

    const handle_chargebee_tokenize = (data) => {
        var token = data.token;

        console.log("chb data", data);

        console.log(
            PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN].chargebee_plan_id,
        );

        fetch(
            //`http://localhost:1337/workspace/billing/web/subscription`,
            `${process.env.API_ROOT}/workspace/${$active_workspace.string_id}/billing/web/subscription`,
            {
                method: "POST",
                mode: "cors",
                body: JSON.stringify({
                    name: input_name,
                    zip: input_billingZip,
                    country: jQuery(".payment-details__select-wrapper select")
                        .countrySelector()
                        .val(),
                    vat_id: input_vatId,
                    plan_id:
                        PER_SEAT_MAPPING[selected_plan || DEFAULT_PLAN]
                            .chargebee_plan_id,
                    plan_quantity: seat_count,
                    token: token,
                    access_token: access_token,
                    workspace_name: $active_workspace.title,
                    addons: [
                        PER_STORAGE_MAPPING[selected_storage || DEFAULT_STORAGE]
                            .chargebee_addon_id,
                    ].filter((a) => a),
                }),
            },
        )
            .then((response) => response.json())
            .then((data) => {
                console.log(data);

                setTimeout(() => {
                    workspace_list.set([]);
                    set_section("account/workspaces/overview");
                }, 8000);
                /*
                if (is_upgrade == false) {
                    window.location.href = `/welcome?access_token=${control_token}`;
                } else {
                    window.location.href = `/welcome/upgrade?access_token=${control_token}&plan_id=#{plan_id}`;
                }
                */
            })
            .catch(handle_billing_error);
    };

    const handlePurchase = () => {
        billing_processing_state = true;
        billing_purchase_button_text = "Processing";

        console.log(selected_payment_method);

        if (selected_payment_method == "new_card") {
            cardComponent
                .tokenize({
                    lastName: input_name,
                    billingZip: input_billingZip,
                    billingCountry: jQuery(
                        ".payment-details__select-wrapper select",
                    )
                        .countrySelector()
                        .val(),
                })
                .then(handle_chargebee_tokenize)
                .catch(handle_billing_error);
        } else if (selected_payment_method == "existing_card") {
            handle_chargebee_tokenize({
                token: null,
            });
        }
    };

    /*
    fetch(
        `${process.env.API_ROOT}/workspace/${$active_workspace.string_id}/billing/web/subscription?access_token=${access_token}`,
        {
            method: "GET",
            mode: "cors",
        }
    )
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
        })
        .catch(console.log);
        */
</script>

<svelte:head>
    <script
        src="https://js.chargebee.com/v2/chargebee.js"
        on:load={initChargebee()}
    ></script>
</svelte:head>

<div class="settings-holder-content content-active">
    <HeadingContent
            title="{workspace_title}"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview");
            }}
        />
    <!--
    <div class="settings-heading">
        <div
            class="heading-block"
            on:click={() => {
                set_section("account/workspaces/overview");
            }}
        >
            <a class="nav-opener" href="#"><i class="icon icon-navigation" /></a
            ><a class="nav-back" href="#">
                <div class="ico-holder">
                    <i class="icon icon-chevron-left" />
                </div>
                <div class="title-holder">
                    <strong class="settings-title">{workspace_title}</strong>
                </div></a
            >
        </div>
    </div>
    -->
    <div class="settings-content">
        <div class="settings-content-holder">
            <ul class="list-plans list-unstyled">
                <!--{#if selected_plan == null}-->
                <div
                    transition:slide
                    class="header-block"
                    style="margin-top:20px;padding-bottom:0px"
                >
                    <div class="container">
                        <h1>Select a plan</h1>
                        <p>
                            You can update your plan on the workspace page after
                            setting up.
                        </p>
                    </div>
                </div>
                <li
                    transition:slide
                    on:click|preventDefault={() => {
                        select_plan("individual");
                    }}
                >
                    <label class="card-plan-container" for="plan_team">
                        <input id="plan_team" type="radio" name="work_plan" />
                        <div
                            class="card-plan card {selected_plan == 'individual'
                                ? 'card-active'
                                : ''}"
                        >
                            <div class="card-body">
                                <strong class="plan-name">Individual</strong>
                                <div class="plan-cost">
                                    <strong class="sum">$15</strong><span
                                        class="periodicity">/ month</span
                                    >
                                </div>
                                <div class="plan-description">
                                    <p>
                                        For individual professionals
                                        <br /><br />
                                    </p>
                                    <p class="text-secondary">
                                        Does not include collaboration features
                                    </p>
                                </div>
                                <div class="plan-info">
                                    <p>billed annually</p>
                                </div>
                                <ul class="list-features">
                                    <li>High-Fidellity Uncompressed Uploads</li>
                                    <li>Asset containers</li>
                                    <li>1,000 Tracks</li>
                                    <li>15 GB of Storage</li>
                                </ul>
                            </div>
                        </div>
                    </label>
                </li>

                <li
                    transition:slide
                    on:click|preventDefault={() => {
                        select_plan("team");
                    }}
                >
                    <label class="card-plan-container" for="plan_team">
                        <input id="plan_team" type="radio" name="work_plan" />
                        <div
                            class="card-plan card {selected_plan == 'team'
                                ? 'card-active'
                                : ''}"
                        >
                            <div class="card-body">
                                <strong class="plan-name">Business</strong>
                                <div class="plan-cost">
                                    <strong class="sum">$25</strong><span
                                        class="periodicity">/ month</span
                                    >
                                </div>
                                <div class="plan-description">
                                    <p>
                                        Best for collaborators and mid-sized
                                        teams
                                    </p>
                                    <p class="text-success">
                                        Collaborative worspaces enabled
                                    </p>
                                </div>
                                <div class="plan-info">
                                    <p>billed annually</p>
                                </div>
                                <ul class="list-features">
                                    <li>
                                        <strong
                                            >Everything in Individual plus...</strong
                                        >
                                    </li>
                                    <li>Spaces, Projects & Shared playlists</li>
                                    <li>Unlimited Projects</li>
                                    <li>
                                        Shared team workspaces with up to 10
                                        seats
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </label>
                </li>

                <li
                    transition:slide
                    on:click|preventDefault={() => {
                        select_plan("organisation");
                    }}
                >
                    <label class="card-plan-container" for="plan_organisation">
                        <input
                            id="plan_organisation"
                            type="radio"
                            name="work_plan"
                        />
                        <div
                            class="card-plan card card-plan-double {selected_plan ==
                            'organisation'
                                ? 'card-active'
                                : ''}"
                        >
                            <div class="card-body">
                                <strong class="plan-name">Enterprise</strong>
                                <div class="plan-cost">
                                    <strong class="sum">$50</strong><span
                                        class="periodicity">/ month</span
                                    >
                                </div>
                                <div class="plan-description">
                                    <p>
                                        The very best Vollume Control has to
                                        offer
                                    </p>
                                    <p class="text-success">
                                        Collaborative worspaces enabled
                                    </p>
                                </div>
                                <div class="plan-info">
                                    <p>billed annually</p>
                                </div>
                                <ul class="list-features">
                                    <li>
                                        <strong
                                            >Everything in Team plus...</strong
                                        >
                                    </li>
                                    <li>SAML SSO</li>
                                    <li>2 Factor Authentication</li>
                                    <li>Unlimited seats</li>
                                    <li>Priority support</li>
                                    <li style="visibility:hidden">&nbsp;</li>
                                    <li style="visibility:hidden">&nbsp;</li>
                                </ul>
                            </div>
                        </div>
                    </label>
                </li>
                <!--{/if}-->
            </ul>

            <!--
                {#if selected_plan != null}
                    <div
                        transition:slide
                        class="card-h-100"
                        style="margin-bottom: 30px"
                    >
                        <div class="card-evary-goods card-join-bottom card">
                            <div class="card-body">
                                <div class="df-row gx-2">
                                    <div class="col-12 col-md-6">
                                        <div class="user-block">
                                            <div class="user-text">
                                                <p>
                                                    <strong class="name"
                                                        >Plan</strong
                                                    >
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="df-row gx-2">
                                            <div class="col-12 col-md-8" />
                                            <div class="col-12 col-md-4">
                                                <div class="package">
                                                    <div class="top">
                                                        <strong class="value"
                                                            >{currently_selected_plan_readable}
                                                        </strong>
                                                    </div>
                                                    <div class="bottom">
                                                        <a
                                                            href="#modal-plan"
                                                            on:click|preventDefault={() => {
                                                                select_plan(null);
                                                            }}>Change plan</a
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <p>
                                            Choose the Vollume plan that best suits
                                            your needs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            -->

            <div class="section-main" style="padding: 0px;">
                {#if selected_storage == null}
                    <div
                        transition:slide
                        class="header-block"
                        style="margin-top:40px;padding-bottom:0px"
                    >
                        <div class="container">
                            <h1>Add storage</h1>
                            <p>
                                You can update storage on the workspace page
                                after setting up.
                            </p>
                        </div>
                    </div>
                {/if}
                <div class="container" style="padding: 0px;">
                    <div
                        class="card-setup card"
                        style="margin-bottom: 0.9375rem;"
                    >
                        <div class="card-body">
                            <div class="df-row gx-2">
                                <div class="col-12 col-md-6">
                                    <div class="user-block">
                                        <div class="user-text">
                                            <p>
                                                <strong class="name"
                                                    >Storage</strong
                                                >
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="df-row gx-2">
                                        <div class="col-12 col-md-8" />
                                        <div class="col-12 col-md-4">
                                            <div class="package">
                                                <div class="top">
                                                    <strong class="value"
                                                        >{selected_storage &&
                                                        selected_storage !=
                                                            "storage_default"
                                                            ? PER_STORAGE_MAPPING[
                                                                  selected_storage
                                                              ].readable
                                                            : PER_STORAGE_MAPPING.storage_default.readable(
                                                                  selected_plan,
                                                              )}
                                                    </strong>
                                                    <!--
                                                    {#if current_storage_price != 0}
                                                        <span class="sum"
                                                            >+${current_storage_price}.00</span
                                                        >
                                                    {:else}
                                                        <span class="sum"
                                                            >Default</span
                                                        >
                                                    {/if}
                                                    -->
                                                </div>
                                                <div class="bottom">
                                                    <!-- This link should call modal .modal-storage--><a
                                                        href="#modal-storage"
                                                        on:click|preventDefault={() => {
                                                            storage_section_opened =
                                                                !storage_section_opened;
                                                            /*
                                                            select_storage(
                                                                null,
                                                            );
                                                            */
                                                        }}>Change storage</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <p>
                                        Add more space to your plan to securely
                                        store more files.
                                    </p>
                                </div>
                            </div>
                            <ul
                                class="radio-list-storage radio-list list-unstyled"
                            >
                                {#if selected_storage == "storage_default" || storage_section_opened}
                                    <li
                                        transition:slide
                                        on:click|preventDefault={() => {
                                            storage_section_opened = false;
                                            select_storage("storage_default");
                                        }}
                                    >
                                        <label
                                            class="radio-custom"
                                            for="storage_250GB"
                                        >
                                            <input
                                                id="storage_250GB"
                                                type="radio"
                                                name="storage_size"
                                                checked={selected_storage ==
                                                    "storage_default"}
                                            /><span class="radio-custom__box"
                                                ><span
                                                    class="df-row df-nowrap df-jcsb gx-2"
                                                    ><span class="col-12"
                                                        ><span
                                                            class="df-row gx-1"
                                                        >
                                                            <span
                                                                class="col-auto"
                                                                ><span
                                                                    class="radio-custom__input"
                                                                /></span
                                                            ><span class="col"
                                                                ><span
                                                                    class="radio-custom__label"
                                                                    >{PER_STORAGE_MAPPING.storage_default.readable(
                                                                        selected_plan,
                                                                    )}, shared
                                                                    storage
                                                                    <span
                                                                        class="text-secondary-dark"
                                                                        >(Default)</span
                                                                    ></span
                                                                ></span
                                                            ></span
                                                        ></span
                                                    ></span
                                                ></span
                                            >
                                        </label>
                                    </li>
                                {/if}
                                {#if selected_storage == "storage_1TB" || storage_section_opened}
                                    <li
                                        transition:slide
                                        on:click|preventDefault={() => {
                                            storage_section_opened = false;
                                            select_storage("storage_1TB");
                                        }}
                                    >
                                        <label
                                            class="radio-custom"
                                            for="storage_1TB"
                                        >
                                            <input
                                                id="storage_1TB"
                                                type="radio"
                                                name="storage_size"
                                                checked={selected_storage ==
                                                    "storage_1TB"}
                                            /><span class="radio-custom__box"
                                                ><span
                                                    class="df-row df-nowrap df-jcsb gx-2"
                                                    ><span class="col-auto"
                                                        ><span
                                                            class="df-row gx-1"
                                                        >
                                                            <span
                                                                class="col-auto"
                                                                ><span
                                                                    class="radio-custom__input"
                                                                /></span
                                                            ><span class="col"
                                                                ><span
                                                                    class="radio-custom__label"
                                                                    >1 TB,
                                                                    shared
                                                                    storage</span
                                                                ></span
                                                            ></span
                                                        ></span
                                                    ><span class="col-auto">
                                                        <span
                                                            class="radio-custom__price"
                                                            >+${PER_STORAGE_MAPPING[
                                                                "storage_1TB"
                                                            ].price}.00 / month</span
                                                        ></span
                                                    ></span
                                                ></span
                                            >
                                        </label>
                                    </li>
                                {/if}
                                {#if selected_storage == "storage_2TB" || storage_section_opened}
                                    <li
                                        transition:slide
                                        on:click|preventDefault={() => {
                                            storage_section_opened = false;
                                            select_storage("storage_2TB");
                                        }}
                                    >
                                        <label
                                            class="radio-custom"
                                            for="storage_2TB"
                                        >
                                            <input
                                                id="storage_2TB"
                                                type="radio"
                                                name="storage_size"
                                                checked={selected_storage ==
                                                    "storage_2TB"}
                                            /><span class="radio-custom__box"
                                                ><span
                                                    class="df-row df-nowrap df-jcsb gx-2"
                                                    ><span class="col-auto"
                                                        ><span
                                                            class="df-row gx-1"
                                                        >
                                                            <span
                                                                class="col-auto"
                                                                ><span
                                                                    class="radio-custom__input"
                                                                /></span
                                                            ><span class="col"
                                                                ><span
                                                                    class="radio-custom__label"
                                                                    >2 TB,
                                                                    shared
                                                                    storage</span
                                                                ></span
                                                            ></span
                                                        ></span
                                                    ><span class="col-auto">
                                                        <span
                                                            class="radio-custom__price"
                                                            >+${PER_STORAGE_MAPPING[
                                                                "storage_2TB"
                                                            ].price}.00 / month</span
                                                        ></span
                                                    ></span
                                                ></span
                                            >
                                        </label>
                                    </li>
                                {/if}
                                {#if selected_storage == "storage_5TB" || storage_section_opened}
                                    <li
                                        transition:slide
                                        on:click|preventDefault={() => {
                                            storage_section_opened = false;
                                            select_storage("storage_5TB");
                                        }}
                                    >
                                        <label
                                            class="radio-custom"
                                            for="storage_5TB"
                                        >
                                            <input
                                                id="storage_5TB"
                                                type="radio"
                                                name="storage_size"
                                                checked={selected_storage ==
                                                    "storage_5TB"}
                                            /><span class="radio-custom__box"
                                                ><span
                                                    class="df-row df-nowrap df-jcsb gx-2"
                                                    ><span class="col-auto"
                                                        ><span
                                                            class="df-row gx-1"
                                                        >
                                                            <span
                                                                class="col-auto"
                                                                ><span
                                                                    class="radio-custom__input"
                                                                /></span
                                                            ><span class="col">
                                                                <span
                                                                    class="radio-custom__label"
                                                                    >5 TB,
                                                                    shared
                                                                    storage</span
                                                                ></span
                                                            ></span
                                                        ></span
                                                    ><span class="col-auto">
                                                        <span
                                                            class="radio-custom__price"
                                                            >+${PER_STORAGE_MAPPING[
                                                                "storage_5TB"
                                                            ].price}.00 / month</span
                                                        ></span
                                                    ></span
                                                ></span
                                            >
                                        </label>
                                    </li>
                                {/if}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-main" style="padding: 0px;">
                {#if selected_seats == false}
                    <div
                        transition:slide
                        class="header-block"
                        style="margin-top:40px;padding-bottom:0px"
                    >
                        <div class="container">
                            <h1>Add seats</h1>
                            <p style="margin-bottom:0;padding-bottom:20px">
                                You can update seats on the workspace page after
                                setting up.
                            </p>
                        </div>
                    </div>
                {/if}
                <div class="container">
                    <div class="card-setup card">
                        <div class="card-body">
                            <div class="df-row gx-2">
                                <div class="col-12 col-md-6">
                                    <div class="user-block">
                                        <div class="user-text">
                                            <p>
                                                <!-- change plan font color to grey and font weight -->
                                                <strong class="name"
                                                    >Seats <span class="sum"
                                                        >({currently_selected_plan_readable}
                                                        plan)</span
                                                    ></strong
                                                >
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="df-row gx-2">
                                        <div class="col-12 col-md-8" />
                                        <div class="col-12 col-md-4">
                                            <div class="package">
                                                <div class="top">
                                                    <strong class="value"
                                                        >{seat_count} Seats
                                                    </strong><span class="sum"
                                                        >+${current_price_per_seat *
                                                            seat_count}.00</span
                                                    >
                                                </div>
                                                <div class="bottom">
                                                    <!-- This link should call modal .modal-storage--><a
                                                        href="#modal-storage"
                                                        on:click|preventDefault={() => {
                                                            selected_seats = false;
                                                        }}>+ Additional users</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12">
                                    <p>
                                        You can update seats on the workspace
                                        page after setting up.
                                    </p>
                                </div>
                                {#if selected_seats == false}
                                    <div
                                        transition:slide
                                        class="col-12 col-md-12"
                                    >
                                        <div
                                            class="contributors-input-container"
                                        >
                                            <div class="df-row df-jce gx-3">
                                                <div class="col-auto">
                                                    <input
                                                        class="inc-dec-button"
                                                        type="button"
                                                        value="−"
                                                        on:click={() =>
                                                            decrement_seat_count()}
                                                    />&nbsp;
                                                    <input
                                                        class="number-input"
                                                        type="text"
                                                        value={seat_count}
                                                    />&nbsp;
                                                    <input
                                                        class="inc-dec-button"
                                                        type="button"
                                                        value="+"
                                                        on:click={() =>
                                                            increment_seat_count()}
                                                    />
                                                </div>
                                                <div class="col">
                                                    <div
                                                        class="price-description"
                                                    >
                                                        <strong class="sum"
                                                            >+${current_price_per_seat *
                                                                seat_count}.00 /
                                                            month</strong
                                                        ><span
                                                            class="price-info"
                                                            >USD ${current_price_per_seat}.00
                                                            x {seat_count}
                                                            seats x Forever</span
                                                        >
                                                        <!-- To make block .price-info visible class .d-none should be deleted--><span
                                                            class="price-info text-success d-none"
                                                            >You will be
                                                            upgraded to the Team
                                                            plan</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="buttons-row df-row df-jce">
                                            <div class="col-auto">
                                                <a
                                                    class="btn btn-primary"
                                                    href="#a"
                                                    on:click={() => {
                                                        selected_seats = true;
                                                    }}>Confirm</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="payment-details section-checkout section-main">
                <div class="header-block" style="margin-top:40px">
                    <div class="container-lg">
                        <h1>Checkout</h1>
                        <p>
                            Enter billing information finish your workspace
                            creation
                        </p>
                    </div>
                </div>
                <div class="container">
                    <div class="payment-details__card card-checkout card">
                        <div class="card-body">
                            <div class="payment-details__method-block">
                                {#if $active_subscription.raw.card && $active_subscription.raw.card.card_type}
                                    <div
                                        on:click={() => {
                                            selected_payment_method =
                                                "existing_card";
                                        }}
                                        class="payment-details__method method-credit {selected_payment_method ==
                                        'existing_card'
                                            ? 'active'
                                            : ''}"
                                    >
                                        <div class="payment-details__radio" />

                                        <span class="col"
                                            ><span class="radio-custom__label"
                                                >&nbsp;&nbsp;Saved card {$active_subscription
                                                    .raw.card.card_type}
                                                {$active_subscription.raw.card
                                                    .masked_number}</span
                                            >
                                        </span>
                                    </div>
                                {/if}
                                <div
                                    on:click={() => {
                                        if (
                                            selected_payment_method !=
                                            "new_card"
                                        ) {
                                            selected_payment_method =
                                                "new_card";
                                            initChargebee();
                                            setTimeout(() => {
                                                initRegionSelector();
                                            }, 500);
                                        }
                                    }}
                                    class="payment-details__method method-credit {$active_subscription
                                        .raw.card == null ||
                                    selected_payment_method == 'new_card'
                                        ? 'active'
                                        : ''}"
                                >
                                    <div class="payment-details__radio" />
                                    <img
                                        src="../images/sep22/payments.svg"
                                        alt="credit card"
                                    />
                                </div>
                                <!--<div
                                    class="payment-details__method method-paypal"
                                >
                                    <div class="payment-details__radio" />
                                    <img
                                        src="../images/sep22/paypal.svg"
                                        alt="paypal"
                                    />
                                </div>-->
                            </div>
                            {#if selected_payment_method == "new_card"}
                                <form
                                    transition:slide
                                    class="payment-details__form-payment credit-card-form"
                                    id="credit-card-form"
                                    method="post"
                                    action="/"
                                >
                                    <div class="credit-card-form__wrapp">
                                        <div class="form-group">
                                            <input
                                                id="card-name"
                                                type="text"
                                                name="credit-name"
                                                placeholder="Cardholder name"
                                                data-required="true"
                                                bind:value={input_name}
                                            />
                                            <div class="error">
                                                Enter a valid name
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <!--<input
                                                id="card-number"
                                                type="text"
                                                name="credit-number"
                                                placeholder="Card number"
                                                data-required="true"
                                            />-->
                                            <div
                                                id="card-number"
                                                class="card-number"
                                            />
                                            <div class="error">
                                                Enter a valid card number
                                            </div>
                                        </div>
                                        <div class="df-row gx-1">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div
                                                        id="card-expiry"
                                                        class="card-number"
                                                    />
                                                    <div class="error">
                                                        Enter a valid expiration
                                                        date
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div
                                                        id="card-cvc"
                                                        class="card-number"
                                                    />
                                                    <div class="error">
                                                        Enter a valid security
                                                        code
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="divider" />
                                    </div>
                                    <div class="df-row gx-1">
                                        <div class="col-7 col-md-9">
                                            <div
                                                class="payment-details__select-wrapper"
                                            >
                                                <select
                                                    bind:value={input_billingCountry}
                                                    data-role="country-selector"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-5 col-md-3">
                                            <div class="form-group">
                                                <input
                                                    id="credit-postal"
                                                    type="text"
                                                    name="credit-postal"
                                                    placeholder="Postal code"
                                                    data-required="true"
                                                    bind:value={input_billingZip}
                                                />
                                                <div class="error">
                                                    Enter a valid postal code
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input
                                            id="credit-vat"
                                            type="text"
                                            name="credit-vat"
                                            placeholder="Vat number (optional)"
                                            bind:value={input_vatId}
                                        />
                                        <div class="error">
                                            Enter a valid vat number
                                        </div>
                                    </div>
                                    <div class="payment-details__policy-block">
                                        <div class="form-group">
                                            <div class="policy-block">
                                                <input
                                                    id="credit-policy"
                                                    type="checkbox"
                                                    name="credit-policy"
                                                    data-required="true"
                                                />
                                                <label
                                                    class="payment-details__policy-label"
                                                    for="credit-policy"
                                                    aria-label="Accept Privacy Policy and Terms Of Service"
                                                    >I agree to the Vollume <a
                                                        href="#a"
                                                        >Terms Of Service</a
                                                    >
                                                    and
                                                    <a href="#a"
                                                        >Privacy Policy</a
                                                    ></label
                                                >
                                            </div>
                                            <div
                                                class="d-lg-none col-12 col-sm-6 col-md-auto"
                                            >
                                                <a
                                                    class="btn btn-dark"
                                                    href="#a"
                                                    on:click={() => {
                                                        summary_sidebar_active =
                                                            !summary_sidebar_active;
                                                    }}>Show details</a
                                                >
                                                <br /><br />
                                            </div>
                                            <div
                                                class="d-lg-none col-12 col-md-auto col-lg-12 col-sm-12"
                                            >
                                                <input
                                                    class="btn btn-primary"
                                                    type="submit"
                                                    value={billing_purchase_button_text}
                                                    disabled={billing_processing_state}
                                                    on:click={() => {
                                                        handlePurchase();
                                                    }}
                                                />
                                                <img
                                                    src="images/spinner.svg"
                                                    alt="vollume"
                                                    width="48"
                                                    height="48"
                                                /> Purchasing
                                            </div>
                                            <div class="error">
                                                Accept terms of service and
                                                privacy policy
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="payment-details__submit-block"
                                    />
                                </form>
                            {/if}
                            <form
                                class="payment-details__form-payment paypal-form"
                                method="post"
                                action="/"
                            >
                                <div class="df-row gx-1">
                                    <div class="col-7 col-md-9">
                                        <div
                                            class="payment-details__select-wrapper"
                                        >
                                            <select
                                                data-role="country-selector"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-5 col-md-3">
                                        <div class="form-group">
                                            <input
                                                id="paypal-postal"
                                                type="text"
                                                name="paypal-postal"
                                                placeholder="Postal code"
                                                data-required="true"
                                            />
                                            <div class="error">
                                                Enter a valid postal code
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="paypal-vat"
                                        type="text"
                                        name="paypal-vat"
                                        placeholder="Vat number (optional)"
                                    />
                                    <div class="error">
                                        Enter a valid vat number
                                    </div>
                                </div>
                                <div class="payment-details__policy-block">
                                    <div class="form-group">
                                        <div class="policy-block">
                                            <input
                                                id="paypal-policy"
                                                type="checkbox"
                                                name="paypal-policy"
                                                data-required="true"
                                            />
                                            <label
                                                class="payment-details__policy-label"
                                                for="paypal-policy"
                                                aria-label="Accept Privacy Policy"
                                                >I agree to the Vollume <a
                                                    href="#a"
                                                    >Terms Of Service</a
                                                >
                                                and
                                                <a href="#a">Privacy Policy</a
                                                ></label
                                            >
                                        </div>
                                        <div class="error">
                                            Accept terms of service and privacy
                                            policy
                                        </div>
                                    </div>
                                </div>
                                <div class="payment-details__submit-block" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-summary card">
                <div class="card-body">
                    <div class="block-top">
                        <div class="header-row-small">
                            <h1 class="h6 d-lg-none">Checkout review</h1>
                            <h1 class="h6 d-none d-lg-block">
                                Price breakdown
                            </h1>
                            {#if $workspace_id == undefined}<a
                                    class="link-close"
                                    href="#a"
                                    on:click={() => {
                                        if (!summary_sidebar_active) {
                                            set_section("step_one");
                                        } else {
                                            summary_sidebar_active =
                                                !summary_sidebar_active;
                                        }
                                    }}><i class="ico ico-close" /></a
                                >{/if}
                        </div>
                        <hr class="divider full-width" />
                        <dl class="plan-name-list df-row df-aic gx-1">
                            <dt class="plan-name col-auto">Plan name:</dt>
                            <dd class="plan-name__data col-auto">
                                <span class="badge"
                                    >{currently_selected_plan_readable}</span
                                >
                            </dd>
                        </dl>
                        <hr class="divider" />
                        <ul class="radio-list df-row gx-2">
                            <li class="col-6">
                                <label class="radio-custom" for="yearly">
                                    <input
                                        id="yearly"
                                        type="radio"
                                        name="plan_periodicity"
                                        checked
                                    /><span
                                        class="radio-custom__input"
                                    /><strong class="radio-custom__label"
                                        >Yearly<span
                                            class="label-small text-success"
                                            >50% discount</span
                                        ></strong
                                    >
                                </label>
                            </li>
                            <li class="col-6">
                                <label
                                    class="radio-custom disabled"
                                    for="monthly"
                                >
                                    <input
                                        id="monthly"
                                        type="radio"
                                        name="plan_periodicity"
                                    /><span
                                        class="radio-custom__input"
                                    /><strong class="radio-custom__label"
                                        >Monthly<span class="label-small"
                                            >Not available</span
                                        ></strong
                                    >
                                </label>
                            </li>
                        </ul>
                        <hr class="divider" />
                        <div class="table-summary table-flex">
                            <div class="trow">
                                <div class="tcell">Subtotal</div>
                                <div class="tcell">
                                    ${final_price_per_seats * 12 * 2}.00
                                </div>
                            </div>
                            <div class="trow">
                                <div class="tcell">
                                    Discount <span class="badge badge-success"
                                        >Save 50%</span
                                    >
                                </div>
                                <div class="tcell">
                                    -${final_price_per_seats * 12}.00
                                </div>
                            </div>
                            {#if current_storage_price != 0}
                                <div transition:slide class="trow">
                                    <div class="tcell">
                                        {PER_STORAGE_MAPPING[
                                            selected_storage || "storage_250GB"
                                        ].readable} Storage
                                    </div>
                                    <div class="tcell">
                                        ${current_storage_price * 12}.00
                                    </div>
                                </div>
                            {/if}
                            <div class="trow row-total">
                                <div class="tcell">
                                    <div class="cell-holder ws-inherit">
                                        Order total
                                    </div>
                                </div>
                                <div class="tcell">
                                    <div class="cell-holder">
                                        ${final_price * 12}.00
                                    </div>
                                </div>
                            </div>
                            <div class="trow">
                                <div class="tcell">Recurring yearly fee</div>
                                <div class="tcell">
                                    ${final_price * 12}.00
                                    <span class="info">Before taxes</span>
                                </div>
                            </div>
                        </div>
                        <p>
                            You’ll be charged yearly until you cancel your
                            subscription. Previous charges won’t be refunded
                            when you cancel unless it’s legally required. Your
                            payment data is encrypted and secure.
                        </p>
                        <p>All amounts shown in U.S. dollars</p>
                    </div>
                    <div class="block-bottom">
                        <div class="buttons-row df-row df-md-jce">
                            <!--
                                <div class="col-12 col-md-auto d-lg-none">
                                <a
                                    class="btn btn-dark"
                                    href="#a"
                                    on:click={() => {
                                        set_section("step_one");
                                    }}>Rename Workspace</a
                                >
                            </div>
                            -->
                            <div class="col-12 col-md-auto col-lg-12 col-sm-12">
                                {#if billing_error_text}
                                    <div
                                        class="btn btn-danger"
                                        in:slide
                                        out:slide
                                    >
                                        {billing_error_text}
                                    </div>
                                {/if}
                                <div
                                    class="btn btn-primary"
                                    style="cursor:pointer"
                                    type="submit"
                                    value={billing_purchase_button_text}
                                    disabled={billing_processing_state}
                                    on:click={() => {
                                        handlePurchase();
                                    }}
                                >
                                    {#if billing_processing_state}
                                        <img
                                            src="images/spinner.svg"
                                            alt="vollume"
                                            width="20"
                                            height="20"
                                        /> Purchasing
                                    {:else}
                                        {billing_purchase_button_text}
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--
            <div class="card-h-100">
                <div class="card-evary-goods card-join-bottom card">
                    <div class="card-body">
                        <div class="card-block">
                            <div class="df-row df-aic gx-05">
                                <div class="col-auto">
                                    <div class="logo-holder">
                                        <img
                                            src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                            alt="vollume"
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <div class="card-box">
                                        <div class="card-box-body">
                                            <h3 class="h6 box-title">
                                                Vollume - {billing_info
                                                    .readable_super_short_title_mapping[
                                                    billing_info.plan_id
                                                ]}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-block">
                            <strong class="price-workspace text-white"
                                >${billing_info.plan_amount_usd} Per year.<span
                                    class="fw-normal d-block"
                                    >Renews on
                                    <time datetime="2022-07-23"
                                        >{new Date(
                                            billing_info.next_billing_at
                                        ).toDateString()}</time
                                    ></span
                                ></strong
                            >
                            <p>
                                You’re a member of the Vollume - {$active_workspace.title}
                                with {billing_info.readable_short_title_mapping[
                                    billing_info.plan_id
                                ]} plan. Asset Containers, public presentations,
                                offline playback, and {STORAGE_ADDON_TO_READABLE_TITLE_MAPPING[
                                    billing_info.addon_id
                                ]} storage.
                            </p>
                            <p>
                                <a href="#">See available plans &amp; add-ons</a
                                >
                            </p>
                        </div>
                        <div class="card-block">
                            {#await fetch_workspace_member_list($active_workspace.string_id, $token)}
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="seats-workspace"
                                            >Loading seats information
                                        </span>
                                    </div>
                                </div>
                            {:then member_list}
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="seats-workspace"
                                            >Seats used <span
                                                class="seats-workspace__used"
                                                >{member_list.length || 0}</span
                                            >
                                            of
                                            <span class="seats-workspace__total"
                                                >{billing_info.plan_quantity}</span
                                            ></span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            class="link-sm-blue"
                                            href="#"
                                            on:click={() => {
                                                set_section(
                                                    "account/workspaces/overview/member_list"
                                                );
                                            }}>Manage Seats</a
                                        >
                                    </div>
                                </div>
                            {/await}
                            <div class="card-row df-row df-jcsb gx-1">
                                <div class="col">
                                    <span class="storage-workspace"
                                        >Storage — <span
                                            class="storage-workspace__availible"
                                            >{STORAGE_ADDON_TO_READABLE_TITLE_MAPPING[
                                                billing_info.addon_id
                                            ]}</span
                                        ></span
                                    >
                                </div>
                                <div class="col-auto">
                                    <a class="link-sm-blue" href="#"
                                        >Manage Storage</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-settings-main-footer card bg-transparent-mobile">
                <div class="card-body">
                    <div class="df-row df-aic df-md-jce gx-1">
                        <div class="col-md-auto">
                            <a
                                class="btn btn-dark"
                                href="#"
                                on:click={() => {
                                    set_section(
                                        "account/workspaces/overview/change_plan"
                                    );
                                }}>Change Plan</a
                            >
                        </div>
                        <div class="col-md-auto">
                            <a
                                class="btn btn-danger"
                                href="#"
                                on:click={() => {
                                    cancel_subscription();
                                }}>Cancel Subscribtion</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        -->
        </div>
    </div>
</div>

<style>
    .inc-dec-button,
    .number-input {
        color: #fff;
        text-align: center !important;
        padding: 9px 0px !important;
        font:
            16px/22px "Inter",
            "Arial",
            "Helvetica Neue",
            "Helvetica",
            sans-serif;
        box-sizing: border-box;
        background-color: #303030 !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        background-color: transparent !important;
        border-radius: 8px;
        width: 42px !important;
        height: 42px !important;
        cursor: pointer;
        z-index: 15;
    }

    .inc-dec-button:hover {
        font-weight: bold;
    }

    .card-number {
        color: #fff;
        padding: 12px 16px;
        font:
            16px/22px "Inter",
            "Arial",
            "Helvetica Neue",
            "Helvetica",
            sans-serif;
        box-sizing: border-box;
        background-color: #303030;
        border: 1px solid #3d3d3d;
        border-radius: 8px;
        width: 100%;
    }

    .ws-inherit {
        white-space: inherit !important;
    }

    :global(body) {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
